export const enum authConstants  {
  userLoginRequest = "USER_LOGIN_REQUEST",
  userLoginSuccess = "USER_LOGIN_SUCCESS",
  userLoginFailure = "USER_LOGIN_FAILURE",

  userVerifyOtpRequest = "USER_VERIFY_OTP_REQUEST",
  userVerifyOtpSuccess = "USER_VERIFY_OTP_SUCCESS",
  userVerifyOtpFailure = "USER_VERIFY_OTP_FAILURE",

  userLogoutRequest = "USER_LOGOUT_REQUEST",
  userLogoutSuccess = "USER_LOGOUT_SUCCESS",

  verifyInviteRequest = "USER_INVITE_REQUEST",
  verifyInviteSuccess = "USER_INVITE_SUCCESS",
  verifyInviteFailure = "USER_INVITE_FAILURE",
  verifyInviteReset = "USER_INVITE_RESET",
  
  userResendInviteRequest = "USER_RESEND_INVITE_REQUEST",
  userResendInviteSuccess = "USER_RESEND_INVITE_SUCCESS",
  userResendInviteFailure = "USER_RESEND_INVITE_FAILURE",

  sendOtpRequest = "SEND_OTP_REQUEST",
  sendOtpSuccess = "SEND_OTP_SUCCESS",
  sendOtpFailure = "SEND_OTP_FAILURE",

  resendOtpRequest = "RESEND_OTP_REQUEST",
  resendOtpSuccess = "RESEND_OTP_SUCCESS",
  resendOtpFailure = "RESEND_OTP_FAILURE",
  sendOtpReset = "SEND_OTP_RESET",
};